import FlagIcon from "@mui/icons-material/Flag";
import { Grid, IconButton, useTheme } from "@mui/material";
import React, { FunctionComponent } from "react";
import EditSvg from "SvgIcons/EditSvg";
import QuoteSvg from "SvgIcons/QuoteSvg";

type Props = {
    toggleNote: () => void;
    showNote: boolean;
    toggleQuote: () => void;
    showQuote: boolean;
    toggleAnswerAlert: () => void;
    flagActive: boolean;
    interactionType?: number;
    restrictMedia?: boolean;
    isDisabled?: boolean;
};

const QuoteNoteButtonContainer: FunctionComponent<Props> = ({
    toggleNote,
    showNote,
    toggleQuote,
    showQuote,
    toggleAnswerAlert,
    flagActive,
    interactionType,
    restrictMedia,
    isDisabled,
}) => {
    const theme = useTheme();

    const iconSize = { width: "20px", height: "20px" };

    const renderIconButton = (
        onClick: () => void,
        isActive: boolean,
        IconComponent: React.ElementType,
        iconProps: object = {},
        activeColor: string = "primary",
    ) => (
        <Grid item sx={{ textAlign: "center" }}>
            <IconButton
                onClick={onClick}
                size="large"
                sx={{ mb: "0.5rem", p: "8px" }}
            >
                <IconComponent
                    {...iconSize}
                    {...iconProps}
                    {...{
                        color: isActive ? activeColor : "#1F1F1F",
                        opacity: isActive ? 1 : 0.25,
                    }}
                />
            </IconButton>
        </Grid>
    );
    return (
        <>
            {renderIconButton(
                toggleNote,
                showNote,
                EditSvg,
                {
                    width: "20px",
                    height: "20px",
                },
                theme.palette.primary.main,
            )}

            {interactionType !== 4 &&
                !restrictMedia &&
                renderIconButton(
                    toggleQuote,
                    showQuote,
                    QuoteSvg,
                    {
                        width: "20px",
                        height: "20px",
                    },
                    theme.palette.primary.main,
                )}

            {renderIconButton(toggleAnswerAlert, flagActive, FlagIcon, {
                fontSize: "small",
            })}
        </>
    );
};

export default QuoteNoteButtonContainer;
